import { render } from "./BibimbapBody.vue?vue&type=template&id=20beb3e2&scoped=true"
import script from "./BibimbapBody.vue?vue&type=script&lang=js"
export * from "./BibimbapBody.vue?vue&type=script&lang=js"

import "./BibimbapBody.vue?vue&type=style&index=0&id=20beb3e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20beb3e2"]])

export default __exports__